<template>
  <div id="user-table-component">

    <m-row class="mt-4">
      <m-col lg="6">
        <memlist-text-input 
          :placeholder="$t('COMMON.SEARCH')"
          v-model="text_search"
        />
      </m-col>
      <m-col lg="6">
        <div class="d-flex justify-end mb-2">
          <memlist-icon-button
            class="mr-2"
            icon="menu-icon flaticon2-plus"
            :text="$t('USER.CREATE')"
            variant="primary"
            @click="new_user_clicked"
          />
        </div>
    
      </m-col>
    </m-row>
    

    <memlist-static-table
      id="user-table"
      :fields="fields"
      :items="users"
      ref="userTable"
    >

      <template #cell(actions)="data">
        <div class='d-flex justify-content-end'>
          <memlist-table-button class="mr-3" @click="edit_user_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="delete_user_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')"/>
        </div>
      </template>
    </memlist-static-table>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import dayjs from 'dayjs';
import axios from 'axios';

export default {
  name: 'UserTable',
  components: {

  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages']),

  },
  watch: {
    text_search() {
      
      if (!this.text_search) {
        this.users = this.copy_users.filter(i => true);
      }
      else {
        const lcasetest = this.text_search.toLowerCase();
        this.users = this.copy_users.filter(i => 
          ((i.name || '').toLowerCase().indexOf(lcasetest) !== -1) || 
          ((i.email || '').toLowerCase().indexOf(lcasetest) !== -1) ||
          ((i.phone || '').toLowerCase().indexOf(lcasetest) !== -1));
      }
    }

  },

  emits: ['selected', 'delete', 'create'],
  async mounted() {
    const users = await this.get_users();

    this.users = users;
    this.copy_users = JSON.parse(JSON.stringify(this.users));
  },
  methods: {

    async get_users() {
      try {
        const res = await axios.get(`/access/users`);

        if (res.status === 200) {
          return res.data;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_GET'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_GET'));
      }

      return [];
    },

    async refresh() {
      const users = await this.get_users();

      this.users = users;
      this.copy_users = JSON.parse(JSON.stringify(this.users));
    },

    row_class(item, type) {
      if (!item || type !== 'row') return;

      return item.group_id === null ? 'table-danger' : '';
    },

    edit_user_clicked(item) {
      this.$emit('selected', item);
    },

    delete_user_clicked(item) {
      this.$emit('delete', item.user_id);
    },

    new_user_clicked() {
      this.$emit('create');
    },

    if_null_empty(value) {
      if (!value) {
        return '';
      }

      return value;
    },
  },
  data() {
    return {
      text_search: null,
      users: [],
      copy_users: [],
      user: {},

      fields: [
        {
          key: 'user_id',
          label: this.$t('USER.ID'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },
        {
          key: 'name',
          label: this.$t('USER.NAME'),
          sortable: false,
          mobile: true,
          tdClass: 'td-overflow',
          thClass: 'td-overflow',
          formatter: (_, __, item) => {
            return this.if_null_empty(item.firstname) + ' ' + this.if_null_empty(item.lastname) + ' ' + this.if_null_empty(item.email);
          }
        },
        {
          key: 'group_name',
          label:  this.$t('USER.GROUP'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short5',
          thClass: 'td-short5'
        },
        {
          key: 'created_at',
          label: this.$t('USER.CREATED_AT'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            return dayjs(item.created_at).format('YYYY-MM-DD');
          }
        },
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short4',
          thClass: 'td-short4'

        },
      ],
    };
  },
  
};
</script>
